// components/IframeBlockerOverlay.jsx
import { createPortal } from "react-dom";

export const IframeBlockerOverlay = () => {
  return createPortal(
    <div className="fixed inset-0 z-[9999] pointer-events-auto" />,
    document.body
  );
};
